import { populate } from '../populate';
import type { RawLayoutData } from '../types/RawLayout';
import type { RootedLayout } from '../types/LayoutShapes';
import { getLayoutClassByPath } from './layoutModules';

// Creates a layout instance from raw layout JSON (e.g., fetched remotely)
export function createLayoutInstanceFromRaw<T extends RootedLayout>(raw: RawLayoutData): T {
  // eslint-disable-next-line @typescript-eslint/naming-convention,@typescript-eslint/explicit-function-return-type
  function LayoutInstance(this: unknown) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error populate assigns dynamic keys based on raw.list
    populate(this, raw);
  }

  // Attach raw to the constructor for animation system compatibility
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  (LayoutInstance as unknown as { raw: RawLayoutData }).raw = raw;

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return new (LayoutInstance as unknown as new () => T)();
}

//

// Creates a layout instance from a file in /layouts by its path (e.g., "common/buttons/ButtonLargeLayout.ts" or without extension)
export function createLayoutInstanceFromPath<T extends RootedLayout>(relativePath: string): T {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const Ctor = getLayoutClassByPath<T>(relativePath);
  if (!Ctor) {
    throw new Error(`Layout class not found for path: ${relativePath}`);
  }
  return new Ctor();
}
